import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { MailAppContextDirective } from '@modules/messages/directives/app-mail-app-context.directive';
import { MessageFolder } from '@modules/messages/types/message-folder';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-message-folder-shared',
  templateUrl: './message-folder-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MailAppContextDirective,
    IconComponent,
    DateFormatPipe,
    ItemDescriptionComponent,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
  ],
})
export class MessageFolderSharedComponent extends SharedBaseComponent<MessageFolder> {
  protected override stitchType = StitchType.MESSAGE_FOLDER;

  protected get folder(): MessageFolder {
    return this.stitchItem?.();
  }
}
